/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_573bd922{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.rootVertical_573bd922{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.item_573bd922{-ms-flex-negative:0;flex-shrink:0;display:inherit}\n" }]);
export var root = "root_573bd922";
export var rootVertical = "rootVertical_573bd922";
export var item = "item_573bd922";
//# sourceMappingURL=OverflowSet.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/OverflowSet/OverflowSet.scss.js
// module id = 824
// module chunks = 0